// extracted by mini-css-extract-plugin
export default {"dotsLoadingSpinner":"td78mZIpNdZ-ao4Q8u7Rrg==","dotsLoadingSpinner__spinner":"ZFi+tIakBNl8QP-0TXoWSg==","spin":"JdDeLhNNyOwkwWPTNAGbPA=="};